// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetApiV1Assets (params?: {}): Promise<List>;
    publicGetApiV1Collateral (params?: {}): Promise<List>;
    publicGetApiV1BorrowLendMarkets (params?: {}): Promise<List>;
    publicGetApiV1BorrowLendMarketsHistory (params?: {}): Promise<List>;
    publicGetApiV1Markets (params?: {}): Promise<List>;
    publicGetApiV1Market (params?: {}): Promise<Dict>;
    publicGetApiV1Ticker (params?: {}): Promise<Dict>;
    publicGetApiV1Tickers (params?: {}): Promise<List>;
    publicGetApiV1Depth (params?: {}): Promise<Dict>;
    publicGetApiV1Klines (params?: {}): Promise<List>;
    publicGetApiV1MarkPrices (params?: {}): Promise<List>;
    publicGetApiV1OpenInterest (params?: {}): Promise<List>;
    publicGetApiV1FundingRates (params?: {}): Promise<List>;
    publicGetApiV1Status (params?: {}): Promise<Dict>;
    publicGetApiV1Ping (params?: {}): Promise<string>;
    publicGetApiV1Time (params?: {}): Promise<List>;
    publicGetApiV1Wallets (params?: {}): Promise<List>;
    publicGetApiV1Trades (params?: {}): Promise<List>;
    publicGetApiV1TradesHistory (params?: {}): Promise<List>;
    privateGetApiV1Account (params?: {}): Promise<Dict>;
    privateGetApiV1AccountLimitsBorrow (params?: {}): Promise<Dict>;
    privateGetApiV1AccountLimitsOrder (params?: {}): Promise<Dict>;
    privateGetApiV1AccountLimitsWithdrawal (params?: {}): Promise<Dict>;
    privateGetApiV1BorrowLendPositions (params?: {}): Promise<List>;
    privateGetApiV1Capital (params?: {}): Promise<Dict>;
    privateGetApiV1CapitalCollateral (params?: {}): Promise<Dict>;
    privateGetWapiV1CapitalDeposits (params?: {}): Promise<List>;
    privateGetWapiV1CapitalDepositAddress (params?: {}): Promise<Dict>;
    privateGetWapiV1CapitalWithdrawals (params?: {}): Promise<List>;
    privateGetApiV1Position (params?: {}): Promise<List>;
    privateGetWapiV1HistoryBorrowLend (params?: {}): Promise<List>;
    privateGetWapiV1HistoryInterest (params?: {}): Promise<List>;
    privateGetWapiV1HistoryBorrowLendPositions (params?: {}): Promise<List>;
    privateGetWapiV1HistoryDust (params?: {}): Promise<List>;
    privateGetWapiV1HistoryFills (params?: {}): Promise<List>;
    privateGetWapiV1HistoryFunding (params?: {}): Promise<List>;
    privateGetWapiV1HistoryOrders (params?: {}): Promise<List>;
    privateGetWapiV1HistoryRfq (params?: {}): Promise<List>;
    privateGetWapiV1HistoryQuote (params?: {}): Promise<List>;
    privateGetWapiV1HistorySettlement (params?: {}): Promise<List>;
    privateGetWapiV1HistoryStrategies (params?: {}): Promise<List>;
    privateGetApiV1Order (params?: {}): Promise<Dict>;
    privateGetApiV1Orders (params?: {}): Promise<List>;
    privatePostApiV1AccountConvertDust (params?: {}): Promise<Dict>;
    privatePostApiV1BorrowLend (params?: {}): Promise<Dict>;
    privatePostWapiV1CapitalWithdrawals (params?: {}): Promise<Dict>;
    privatePostApiV1Order (params?: {}): Promise<Dict>;
    privatePostApiV1Orders (params?: {}): Promise<List>;
    privatePostApiV1Rfq (params?: {}): Promise<Dict>;
    privatePostApiV1RfqAccept (params?: {}): Promise<Dict>;
    privatePostApiV1RfqRefresh (params?: {}): Promise<Dict>;
    privatePostApiV1RfqCancel (params?: {}): Promise<Dict>;
    privatePostApiV1RfqQuote (params?: {}): Promise<Dict>;
    privateDeleteApiV1Order (params?: {}): Promise<Dict>;
    privateDeleteApiV1Orders (params?: {}): Promise<List>;
    privatePatchApiV1Account (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
